import { MY_PRODUCT_REGISTRATION_ACCESS_TOKEN } from '../environment'

async function registerSerialNumber(title, state) {
  const headers = new Headers();
  headers.append("Authorization", MY_PRODUCT_REGISTRATION_ACCESS_TOKEN);
  headers.append("Content-Type", "application/json")
  const requestOptions = {
    registrations: [
      {
        productName: title,
        customerEmail: state.email,
        customerName: state.firstName + " " + state.lastName,
        phoneNumber: state.phoneNumber,
        ModelNumber: state.modelNumber,
        serialNumbers: state.serialNumber,
        purchaseDate: state.purchaseDate,
        PlaceofPurchaseOptions: state.purchasePlace,
        ProofofPurchase: state.proofOfPurchaseUrl
      },
    ],
  };

  const response = await fetch("https://product-reg.varify.xyz/api/registrations", { method: "POST", headers, body: JSON.stringify(requestOptions) })
  await response.text();
  return
}

async function getSerialNumberData(serialNumber) {
  try {
    const headers = new Headers();
    headers.append("Authorization", MY_PRODUCT_REGISTRATION_ACCESS_TOKEN);
    headers.append("Content-Type", "application/json")

    const response = await fetch(`https://product-reg.varify.xyz/api/serial_numbers/${serialNumber}`, { method: "GET", headers })

    if (!response.ok) {
      throw new Error("Failed to fetch serial number data");
    }

    const serialNumberData = await response.json();
    return serialNumberData;
  } catch (error) {
    throw new Error("Please Enter Valid Serial Number");
  }
}

function numDaysBetween(d1, d2) {
  const diff = Math.abs(d1.getTime() - d2.getTime());
  return diff / (1000 * 60 * 60 * 24);
}

function formatPrice(price, currency = "$") {
  return `${currency}${(price / 100).toFixed(2)}`
}

async function getProductData(sku) {
  const response = await fetch(`/collections/all?view=json`)
  const { products } = await response.json();
  const productData = products.find((product) => product.sku === sku)
  return productData
}

export { registerSerialNumber, numDaysBetween, formatPrice, getSerialNumberData, getProductData };
